module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_b/main_sp_2e4cffa0d7187d65a116e8d8c3b6f70e.jpg";